import Layout from '@/layout'
import store from '@/store'

const UserType = store.getters.userInfo.dean_type || 'mba'
const pathName = UserType.toUpperCase()

const children = [
  {
    path: 'calendar',
    name: 'Calendar',
    component: () => import('@/views/MyCourse/calendar'),
    meta: { title: '课程日历' }
  },

  {
    path: 'apply-form/:typeid',
    name: 'CourseApplyForm',
    component: () => import('@/views/MyCourse/ApplyAdjustment/courseApplyForm'),
    meta: { title: '课程异动申请', hidden: true }
  },
  {
    path: 'apply-form/detail/:applyid',
    name: 'CourseApplyDetailForm',
    component: () => import('@/views/MyCourse/ApplyAdjustment/courseApplyDetailForm'),
    meta: { title: '课程异动申请详情', hidden: true }
  },
  {
    path: 'my-schedule',
    name: 'MySchedule',
    component: () => import('@/views/MyCourse/' + pathName + '/MySchedule'),
    meta: { title: '我的课表' }
  },
  {
    path: 'MyHomeWork',
    name: 'MyHomeWork',
    component: () => import('@/views/MyCourse/homeWork'),
    meta: { title: '作业上传' }
  },
  {
    path: 'assessment',
    name: 'Assessment',
    component: () => import('@/views/MyCourse/Assessment'),
    meta: { title: '课程评估' }
  },
  {
    path: 'assessment-detail/:id',
    name: 'AssessmentDetail',
    component: () => import('@/views/MyCourse/Assessment/detail'),
    meta: { title: '课程评估详情', hidden: true }
  },
  {
    path: 'course-selection',
    name: 'CourseSelection',
    component: () => import('@/views/MyCourse/CourseSelection'),
    meta: { title: '选课事务' }
  },
  {
    path: 'adjust',
    name: 'ApplyAdjustment',
    component: () => import('@/views/MyCourse/ApplyAdjustment'),
    meta: { title: '课程调整申请' }
  },
  {
    path: 'CourseSelectionDetail',
    name: 'CourseSelectionDetail',
    component: () => import('@/views/MyCourse/CourseSelection/detail-sel'),
    meta: { title: '选课详情', hidden: true, isShowSidebar: false }
  },
  {
    path: 'course-selection/:id',
    name: 'CourseDetail',
    component: () => import('@/views/MyCourse/CourseSelection/detail'),
    meta: { title: '选课详情', hidden: true, isShowSidebar: false }
  }
  // {
  //   path: 'apply-stu-status',
  //   name: 'ApplyStudentStatus',
  //   component: () => import('@/views/MyCourse/ApplyStudentStatus'),
  //   meta: { title: '学籍调整申请' }
  // }
]

if (UserType === 'mba') {
  const plan = {
    path: 'training-plan',
    name: 'TrainingPlan',
    component: () => import('@/views/MyCourse/TrainingPlan'),
    meta: { title: '培养计划' }
  }
  children.splice(1, 0, plan)
}

const myCourse = {
  path: '/my-course',
  component: Layout,
  redirect: '/my-course/calendar',
  title: '我的课程',
  name: 'MyCourse',
  meta: { title: '我的课程', name: 'MyCourse' },
  children
}

export default myCourse
